<script>
    import DropdownArrow from "./DropdownArrow.svelte";
    import SummaryTable from './SummaryTable.svelte';

    export let style;
    export let title;
    export let subTables = [];

    let isExpanded = true;

    const toggleExpand = () => isExpanded = !isExpanded;

</script>

<table class="table">
  <thead class="thead-light" on:click={toggleExpand}>
    <tr>
      <th colspan="2">
        <div class="th-content">
          {title}
          <DropdownArrow rotate={isExpanded ? 0 : 270} />
        </div>
      </th>
    </tr>
  </thead>
  {#if isExpanded}
    <tbody>
      {#if subTables && subTables.length}
        {#each subTables as table}
          <SummaryTable
            title={table.title}
            data={table.data}
            style={'margin-bottom: 0;'}
          />
        {/each}
      {/if}
    </tbody>
  {/if}
</table>

<style>
  .thead-light th {
    position: relative;
    background: #ced4da;
  }

  .th-content {
    display: flex;
    align-items: center;
  }
</style>
